"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = _interopRequireDefault(require("react"));
var _StepConnector = _interopRequireDefault(require("./StepConnector"));
var _Stepper = _interopRequireDefault(require("@mui/material/Stepper"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var dataCy = exports.dataCy = 'Stepper';
var styles = function styles() {
  return {
    root: {
      padding: 0
    }
  };
};
// TODO: remove unused
var Stepper = function Stepper(_ref) {
  var children = _ref.children,
    classes = _ref.classes,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'vertical' : _ref$orientation,
    alternativeLabel = _ref.alternativeLabel,
    activeStep = _ref.activeStep,
    nonLinear = _ref.nonLinear,
    connectorProp = _ref.connector;
  var connector = connectorProp || /*#__PURE__*/(0, _jsxRuntime.jsx)(_StepConnector["default"], {});
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stepper["default"], {
    "data-cy": dataCy,
    classes: classes,
    orientation: orientation,
    alternativeLabel: alternativeLabel,
    activeStep: activeStep,
    nonLinear: nonLinear,
    connector: connector,
    children: children
  });
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(Stepper);